import { Box, Typography } from "@material-ui/core";

const SecurityReviewFrequency = () => {
  return (
    <Box>
      <Typography variant="h4">Security Review Frequency</Typography>
    </Box>
  );
};

export default SecurityReviewFrequency;
